import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  DialogPresets,
  DYNAMIC_COMPONENT_DATA,
} from '@principle-theorem/ng-shared';
import {
  ROMEXIS_CAPTURE_MODES,
  ROMEXIS_INTEGRATION,
  RomexisCaptureMode,
} from '@principle-theorem/principle-bridge-core';
import { snapshot } from '@principle-theorem/shared';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { IIntegrationActionData } from '../../../../integration-action-data';
import { BridgeDeviceSelectorService } from '../../../bridge-device-selector-dialog/bridge-device-selector.service';
import {
  IRomexisBridgeConfigurationData,
  RomexisBridgeConfigurationComponent,
} from '../romexis-bridge-configuration/romexis-bridge-configuration.component';
import { RomexisFeatureService } from '../romexis-feature.service';
import { BridgeCommandsService } from '../../../../bridge-commands.service';

@Component({
  selector: 'pr-romexis-open-patient',
  templateUrl: './romexis-open-patient.component.html',
  styleUrl: './romexis-open-patient.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RomexisOpenPatientComponent {
  isDisabled$: Observable<boolean>;
  captureModes = ROMEXIS_CAPTURE_MODES;

  constructor(
    @Inject(DYNAMIC_COMPONENT_DATA)
    private _data: IIntegrationActionData,
    private _romexis: RomexisFeatureService,
    private _bridgeDeviceSelector: BridgeDeviceSelectorService,
    private _bridgeCommands: BridgeCommandsService,
    private _dialog: MatDialog
  ) {
    this.isDisabled$ = of(this._data.patient).pipe(
      map((patient) => !patient.dateOfBirth)
    );
  }

  async openRomexisSettings(): Promise<void> {
    const bridgeDevices = await snapshot(
      this._bridgeCommands.devicesByIntegration$(ROMEXIS_INTEGRATION)
    );
    this._dialog.open<
      RomexisBridgeConfigurationComponent,
      IRomexisBridgeConfigurationData
    >(
      RomexisBridgeConfigurationComponent,
      DialogPresets.medium({
        data: { bridgeDevices },
      })
    );
  }

  async openRomexis(mode: RomexisCaptureMode): Promise<void> {
    const device =
      await this._bridgeDeviceSelector.selectDevice(ROMEXIS_INTEGRATION);

    if (!device) {
      return;
    }

    await this._romexis.openPatient(this._data.patient, mode, device);
  }
}
